"use strict";

var storage = require("./storage").session;
var tracking = require("./tracking");

var autotypesDiv = document.getElementById("alternative-search-type-CarBodyType");
var modelsDiv = document.getElementById("alternative-search-type-Model");
var autotypesTab = document.getElementById("alternative-search-type-CarBodyType-tab");
var modelsTab = document.getElementById("alternative-search-type-Model-tab");

function selectTab(targetTab)
{
    if (targetTab === autotypesTab.id) {
        modelsDiv.classList.add("hidden");
        autotypesDiv.classList.remove("hidden");

        modelsTab.classList.remove("home-selected-tab");
        autotypesTab.classList.add("home-selected-tab");
        storage.set("altSearchSelTab", targetTab);
    }
    else if (targetTab === modelsTab.id) {
        autotypesDiv.classList.add("hidden");
        modelsDiv.classList.remove("hidden");

        modelsTab.classList.add("home-selected-tab");
        autotypesTab.classList.remove("home-selected-tab");
        storage.set("altSearchSelTab", targetTab);
    }
}

var linkIdMapping = {
    "alternative-search-type-CarBodyType-tab": "bodytype",
    "alternative-search-type-Model-tab": "most"
};

var init = function(){
    var elem = document.querySelector("div[id='alternative-search-tabs-headline']");
    if (elem){
//        var preselectedTab = storage.get("altSearchSelTab");
//        if (preselectedTab){
//            selectTab(preselectedTab);
//        }
        var spans = elem.getElementsByTagName("span");

        Array.prototype.forEach.call(spans, function(span){
            span.addEventListener("click", function(e){
                selectTab(e.target.id);
                tracking.clickEvent("HP_AltSearch", linkIdMapping[e.target.id]);
            });
        });
    }
};

module.exports = {
    init: init
};

